import * as React from "react";
import {DashboardListAccountsRequest} from "../../../../generated/protocol";
import {PagerModel} from "../../list/PagerModel";
import {EntityDataTable} from "../../list/EntityDataTable";
import {AppCtx} from "../../../ioc/ApplicationContext";
import {ListUtils} from "../../list/ListUtils";
import {LoadingViewState} from "../RouterView";
import {ItemView} from "../../../../generated/protocol";
import {Form, FormListener} from "../../form/Form";
import {FormGroup} from "../../form/FormGroup";
import {FormInput} from "../../form/FormInput";
import {createInitialState, ListView} from "../ListView";
import {SelectInput} from "../../form/SelectInput";
import * as _ from "lodash";
import {WALLET_SERVICE_NAME, WalletService} from "../../../service/admin/WalletService";
import * as DateUtils from "../../../utils/DateUtils";


interface State extends LoadingViewState {
    listRequest?: DashboardListAccountsRequest;
    form?: DashboardListAccountsRequest;
    types?: String[];
    statuses?: String[];
    currencies?: String[];
    validationMap?: any;
}

export class AccountsListView extends ListView<State, DashboardListAccountsRequest> implements FormListener<DashboardListAccountsRequest> {
    columns = [
        {property: "id", name: "id", orderBy: "ID"},
        {property: "userId", name: "User Id", orderBy: "USER_ID"},
        {property: "information.name", name: "Name", orderBy: "ACCOUNT_NAME"},
        {property: "currency", name: "Currency", orderBy: "CURRENCY_CODE"},
        {property: "attributes.ROLE", name: "Role"},
        {property: "type", name: "Type", orderBy: "TYPE"},
        {property: "status", name: "Status", orderBy: "STATUS"},
        {
            property: "created", name: "Created", orderBy: "CREATION_DATE", renderer: (property, columnName, item) => {
                return DateUtils.iso(item.created)
            }
        },
        {
            property: "lastModified", name: "Last Modified", renderer: (property, columnName, item) => {
                return item.lastModified && item.lastModified !== "" ? DateUtils.iso(item.lastModified) : ""
            }
        }
    ];
    actions = [
        {id: "view", name: "View", className: "btn btn-primary", iconClassName: "fa fa-eye"}
    ];

    itemService: WalletService;

    constructor(props) {
        super(props, "/accounts");
        this.itemService = AppCtx.resolve<WalletService>(WALLET_SERVICE_NAME);
        this.state.types = ["ANY", "SESSION_ACCOUNT", "STATIC_ACCOUNT", "OPERATOR_ACCOUNT", "SYSTEM_ACCOUNT", "AFFILIATE_ACCOUNT"];
        this.state.statuses = ["ANY", "OPEN", "CLOSED"];
        this.state.currencies = ["ANY", "XSD", "XGC"];

        this.state = createInitialState({limit: 50, orderBy: "ID"}, this.state);
    }

    loadContent(): Promise<any> {
        return undefined;
    }

    formDidUpdate(formModel: DashboardListAccountsRequest, validationMap?: any) {
        this.setState({"form": formModel, validationMap: validationMap});
    }

    pagerChanged(pager: PagerModel) {
        if (pager.orderBy) {
            var listRequest = ListUtils.toListRequest(this.state.listRequest, pager);
            this.setState({listRequest: listRequest});
        }
    }

    onSubmitError(): void {

    };

    onSubmit(): void {
        let listRequest = _.clone(this.state.listRequest);
        listRequest.offset = 0;
        listRequest.orderBy = "ID";

        listRequest.userId = this.state.form.userId;
        listRequest.accountType = this.state.form.accountType;
        listRequest.status = this.state.form.status;
        listRequest.currencyCode = this.state.form.currencyCode;

        this.updateListState(listRequest);
    };


    onAction(item: ItemView, action: string) {
        if (action == "view") {
            this.navigate("/account/" + item.id);
        }
    }

    getTitle() {
        return "Accounts";
    }

    renderContent() {
        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>{this.getTitle()}</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated fadeInRight">

                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>Filter Accounts</h5>
                        </div>
                        <div className="ibox-content">
                            <div className="ibox-content">
                                <Form className="form-horizontal" formListener={this} modelObject={this.state.form}
                                      validationMap={this.state.validationMap}>
                                    <FormGroup className="form-group" model="userId">
                                        <label className="col-lg-2 control-label">User ID</label>
                                        <div className="col-lg-10">
                                            <FormInput className="form-control" model="userId" type="text"/>
                                            <span className="help-block m-b-none">Account owner user id.</span>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className="form-group" model="accountType">
                                        <label className="col-lg-2 control-label">Type</label>
                                        <div className="col-lg-10">
                                            <SelectInput className="form-control" model="accountType"
                                                         values={this.state.types}/>
                                            <span className="help-block m-b-none">Account Type.</span>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className="form-group" model="status">
                                        <label className="col-lg-2 control-label">Status</label>
                                        <div className="col-lg-10">
                                            <SelectInput className="form-control" model="status"
                                                         values={this.state.statuses}/>
                                            <span className="help-block m-b-none">Account Status.</span>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className="form-group" model="currencyCode">
                                        <label className="col-lg-2 control-label">Currency</label>
                                        <div className="col-lg-10">
                                            <SelectInput className="form-control" model="currencyCode"
                                                         values={this.state.currencies}/>
                                            <span className="help-block m-b-none">Account Currency.</span>
                                        </div>
                                    </FormGroup>

                                    <div className="form-group">
                                        <div className="col-lg-offset-2 col-lg-10">
                                            <input className="btn btn-primary" value="List Items" type="submit"/>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>

                    <EntityDataTable service={this.itemService} onPagerChange={this.pagerChanged.bind(this)}
                                     columns={this.columns} listRequest={this.state.listRequest}
                                     onAction={this.onAction.bind(this)} actions={this.actions}/>
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/view/account/AccountsListView.tsx